<template>
  <footer>
    <div class="corzo-footer-wrapper">
      <div class="corzo-footer-container corzo-container clearfix">
        <div class="corzo-footer-column corzo-item-pdlr corzo-column-20">
          <div id="text-7" class="widget widget_text corzo-widget">
            <div class="textwidget">
              <p>
                <img loading="lazy" src="../assets/logo.png" alt="" style="width: 300px;" title="汇德"/></p>
<!--              <p>匯德集团致力于为全球的企业、家族办公室及高净值客户的投资运营、法律架构、家族信托、税收筹划进行一体化的服务。</p>-->
            </div>
          </div>
          <div class="menu-quick-links-container">
            <ul class="gdlr-core-custom-menu-widget">
              <li>
                香港总部<br/>
                <span style="font-size: 15px;">中国香港九龙尖沙咀广东道33号中港城1座1806室</span><br/>
<!--                <span style="font-size: 15px;">Suite 1002，Tower 1，China Hong Kong City，33 Canton Road，Tsim Sha Tsui, Hong Kong</span>-->
              </li>
              <li>
                香港总部<br/>
                <span style="font-size: 15px;">中国香港九龙尖沙咀广东道30号新港中心2座1779室</span><br/>
<!--                <span style="font-size: 15px;">Suite 1779，Tower 2，Silvercord Centre，33 Canton Road，Tsim Sha Tsui, Hong Kong</span>-->
              </li>
              <li>
                上海分部<br/>
                <span style="font-size: 15px;">上海市闵行区古北路1699号1706室</span><br/>
<!--                <span style="font-size: 15px;">Unit 1706-2，17th Floor，1699 Commercial Plaza，1699 Gubei Road，Minhang District，Shanghai</span>-->
              </li>
            </ul>
          </div>
        </div>
        <div class="corzo-footer-column corzo-item-pdlr corzo-column-10">
          <div id="gdlr-core-custom-menu-widget-1" class="widget widget_gdlr-core-custom-menu-widget corzo-widget">
            <h1 class="corzo-widget-title corzo-with-divider">匯德中心</h1>
            <span class="clear"></span>
            <div class="menu-quick-links-container">
              <ul id="menu-quick-links" class="gdlr-core-custom-menu-widget gdlr-core-menu-style-half">
                <li class="menu-item corzo-normal-menu">
                  <a v-on:click="goto('services/1')">服务</a></li>
                <li class="menu-item corzo-normal-menu">
                  <a v-on:click="goto('about')">关于我们</a></li>
                <li class="menu-item corzo-normal-menu">
                  <a v-on:click="goto('contact')">联系我们</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="corzo-footer-column corzo-item-pdlr corzo-column-10">
          <div id="gdlr-core-custom-menu-widget-1" class="widget widget_gdlr-core-custom-menu-widget corzo-widget">
            <h1 class="corzo-widget-title corzo-with-divider">快速链接</h1>
            <span class="clear"></span>
            <div class="menu-quick-links-container">
              <ul id="menu-quick-links" class="gdlr-core-custom-menu-widget gdlr-core-menu-style-half">
                <li class="menu-item corzo-normal-menu">
                  <a href="https://www.investhk.gov.hk/zh-cn.html">香港投资推广署</a></li>
                <li class="menu-item corzo-normal-menu">
                  <a href="https://www.sfc.hk/TC/">香港证券及期货事务监察委员会</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="corzo-footer-column corzo-item-pdlr corzo-column-10"></div>
        <div class="corzo-footer-column corzo-item-pdlr corzo-column-20">
          <div id="text-3" class="widget widget_text corzo-widget">
            <h1 class="corzo-widget-title corzo-with-divider">联系我们</h1>
            <span class="clear"></span>
            <div class="textwidget">
              <p>
                <span style="font-size: 18px; color: #999999; font-weight: 400;">Email</span>
                <br/>
                <span style="font-size: 18px; color: #ffffff; font-weight: 600;">
                        <a href="mailto:info@huidetrust.com" class="__cf_email__">info@huidetrust.com</a></span>
                <br/>
                <span class="gdlr-core-space-shortcode" style="margin-top: -10px;"></span>
                <br/>
                <span style="font-size: 18px; color: #999999; font-weight: 400;">联系电话</span>
                <br/>
                <span style="font-size: 18px; color: #ffffff; font-weight: 600;">+86-021-60908368</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="corzo-copyright-wrapper">
      <div class="corzo-copyright-container corzo-container">
        <div class="corzo-copyright-text corzo-item-pdlr">
          <div class="gdlr-core-social-network-item gdlr-core-item-pdb gdlr-core-none-align"
               style="padding-bottom: 0px;">
<!--            <a href="#" target="_blank" class="gdlr-core-social-network-icon" title="facebook"-->
<!--               style="font-size: 17px; color: #060606; width: 40px; line-height: 40px; background-color: #ffffff; border-radius: 20px; -moz-border-radius: 20px; -webkit-border-radius: 20px;">-->
<!--              <i class="fa fa-wechat"></i>-->
<!--            </a>-->
<!--            <a href="#" target="_blank" class="gdlr-core-social-network-icon" title="linkedin"-->
<!--               style="font-size: 17px; color: #060606; margin-left: 10px; width: 40px; line-height: 40px; background-color: #ffffff; border-radius: 20px; -moz-border-radius: 20px; -webkit-border-radius: 20px;">-->
<!--              <i class="fa fa-telegram"></i>-->
<!--            </a>-->
          </div>
          <span class="gdlr-core-space-shortcode" style="margin-top: 20px;"></span>© 2022 Huide Group |
          <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202013955" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../assets/gonganbu.png" style="float:left; width: 20px; height: 20px;"/>沪公网安备 31011202013955号
          </a>
          |
          <a target="_blank" href="https://beian.miit.gov.cn">ICP备案 沪ICP备2021028602号-1</a>
          <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a href="https://xyt.xcc.cn/getpcInfo?sn=1603324736027217920&language=CN&certType=8&url=*.huidetrust.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
              <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1603324736027217920=*.huidetrust.com.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goto (path) {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      location.href = '#/' + path
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue